import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Offres } from '../models/Offres';
import { Step5 } from '../../../../shared/models/component-messages/diveAT/step5';

@Component({
  selector: 'app-offres',
  templateUrl: './offres.component.html'
})
export class OffresComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'Offres';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  @Input() offres: Offres;

  public step5 = new Step5();

  constructor() {
  }

  public ngOnInit() {
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}
